// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y4Yh","content":"styles_content__1bvKb","tableWrap":"styles_tableWrap__og3i4"};